import * as React from "react";

function SvgCloseIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M15.646 2.066L9.712 8l5.934 5.934a1.21 1.21 0 11-1.712 1.712L8 9.712l-5.934 5.934a1.21 1.21 0 11-1.711-1.712L6.287 8 .354 2.066A1.21 1.21 0 012.066.355L8 6.287 13.934.354a1.21 1.21 0 011.712 1.712z"
                fill="#6C9F39"
            />
        </svg>
    );
}

export default SvgCloseIcon;
